import { gql } from '@apollo/client';
import { BRAND_BASIC_FRAGMENT } from '../../fragments/brandFragments';

export const BRAND_LIST_QUERY = gql`
  query BrandList(
    $first: Int
    $after: String
    $filter: BrandFilterInput
    $forCategory: ID
    $languageCode: LanguageCodeEnum!
  ) {
    brands(
      first: $first
      after: $after
      filter: $filter
      forCategory: $forCategory
    ) {
      edges {
        node {
          ...BrandBasic
          translation(languageCode: $languageCode) {
            name
          }
          sidebarCategories(first: $first) {
            edges {
              node {
                id
                name
                seoTitle
              }
            }
          }
        }
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
  ${BRAND_BASIC_FRAGMENT}
`;
